import { useApiContext } from '@customink/project-service-react-components';

import { useAuth } from '@/contexts/auth/AuthContext';

export const useGetCertificates = () => {
  const api = useApiContext();
  const { personalAccount, user } = useAuth();
  return api.useGetAccountTaxExemptionCertificatesQuery(
    { accountId: personalAccount?.id as string },
    { skip: !user?.isLoggedIn || !personalAccount?.id },
  );
};
